/* Pure marker helpers for the Ankle pain map.
   Kept dependency-free so they can be unit-tested in isolation and reused by
   both the interactive map and any storage/normalisation logic.

   Every marker owns a STABLE, UNIQUE id and its OWN pain-detail fields
   (types, intensity, comment, foot, view, coordinates). Operations are keyed
   by that id and are immutable, so editing / clearing / moving / deleting one
   marker can never touch another. Display numbers are derived from array order
   at render time and are NEVER used as identity. */

let _seq = 0;

// Guaranteed-unique, stable id. Prefer crypto.randomUUID (collision-free);
// fall back to a monotonic sequence so two markers created in the same
// millisecond can never share an id (the previous Date.now()+random scheme
// could collide, which made id-keyed edits hit two markers at once).
export function newMarkerId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  _seq += 1;
  return `m_${Date.now().toString(36)}_${_seq}_${Math.random().toString(36).slice(2)}`;
}

// A fresh marker always starts with EMPTY details — it never inherits the
// previous marker's answers.
export function createMarker(view, foot, x_pct, y_pct) {
  return {
    id: newMarkerId(),
    view,
    foot,
    x_pct: +Number(x_pct).toFixed(4),
    y_pct: +Number(y_pct).toFixed(4),
    types: [],
    intensity: null,
    comment: "",
  };
}

// Immutable, id-scoped update — only the matching marker is replaced.
export function updateMarkerList(markers, id, patch) {
  return markers.map((m) => (m.id === id ? { ...m, ...patch } : m));
}

export function removeMarkerFromList(markers, id) {
  return markers.filter((m) => m.id !== id);
}
